// PartnersSection.jsx
import React, { useRef, useState } from "react";
import ContactForm from "./ContactForm";
import Tabs from "./Sidetab";
import SupportBox from "./SupportBox";
import CTA from "./CTASection"; // Make sure this is exporting CTASection
import ComplianceContent from "./ComplianceContent";
import Accelerator from "./AcceleratorContent";
import Elevate from "./ElevateContent";
import HeroPartners from "./PartnersHero";
import HeroAccelerate from "./AcceleratorHero";
import HeroElevate from "./ElevateHero";
import "../styles/RegulatoryCompliance.css";

const PartnersSection = () => {
  const [activeTab, setActiveTab] = useState("Nexa Partners");
  const formRef = useRef(null);

  const handleBookClick = () => {
    if (formRef.current) {
      formRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
      formRef.current.querySelector("input")?.focus();

      // Optional: highlight the form
      formRef.current.classList.add("highlight");
      setTimeout(() => {
        formRef.current.classList.remove("highlight");
      }, 2000);
    }
  };

  const renderContent = () => {
    switch (activeTab) {
      case "Nexa Partners":
        return <ComplianceContent />;
      case "Nexa Elevate":
        return <Elevate />;
      case "Nexa Accelerate":
        return <Accelerator />;
      default:
        return <ComplianceContent />;
    }
  };

  const renderHero = () => {
    switch (activeTab) {
      case "Nexa Partners":
        return <HeroPartners />;
      case "Nexa Elevate":
        return <HeroElevate />;
      case "Nexa Accelerate":
        return <HeroAccelerate />;
      default:
        return <HeroPartners />;
    }
  };

  return (
    <div className="compliance-wrapper">
      {renderHero()}
      <div className="compliance-container">
        <div className="sidebar-form">
          <Tabs onSelectTab={setActiveTab} activeTab={activeTab} />
          <ContactForm ref={formRef} />
          <SupportBox />
          <CTA onClick={handleBookClick} /> {/* Updated here */}
        </div>
        {renderContent()}
      </div>
    </div>
  );
};

export default PartnersSection;
